module.exports = __webpack_public_path__ + "media/src/assets/images/lps-pet-aab8eb66fc65a6cf7ddcc94e4033d2d6.png";